<template>
  <div class="indexPageBox">
    <div class="bannerBox1">
      <HeaderCom></HeaderCom>
      <div style="height: 520px">
        <div class="banner_item" style="background-image: url('static/image/cm_banner.png');">
          <div class="banner_item1_content">
            <p>“消防知识培训”训管通系统</p>
            <p class="txt1">
              训管通系统深度围绕智慧消防建设依据和标准，遵循“不重复投入硬件资
              源、不独立建立数据库、不单独运营维护”原则而建立
            </p>
            <div class="item1_infoBox cm_btn">
              立即申请
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part1Box">
      <div class="part1_content">
        <div class="part1_header">
          <span>方案背景</span>
          <span>训管通系统深度围绕智慧消防建设依据与标准</span>
        </div>
        <div class="part1_section">
          <div>
            <span>“消防知识培训”安全教育</span>
            <span></span>
            <span>为了加强消防知识培训，强化消防安全意识，有效降低火灾发生率和火灾伤亡率，消防部门按照规定需定期对社会单位进行消防安全培训、教育、座谈会议等，但目前普遍存在各大队上报培训计划不明确、现场培训过程不规范、培训报告弄虚作假等情况</span>
          </div>
          <div>
            <img src="static/image/cm_programme.png" alt="">
          </div>
        </div>
        <div class="part3_img">
          <img src="static/image/cm_Train.png" alt="">
        </div>
      </div>
    </div>
    <div class="part2Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">方案简介</span>
          <span class="part1_header_txt2">训管通系统深度围绕智慧消防建设依据与标准</span>
          <span class="part1_header_txt3">训管通系统深度围绕智慧消防建设依据与标准，遵循“不重复投入硬件资源、不独立建立数据库、不单独运营维护＂原则而建立。系统依托于消防微信公众号，支(大)队领导、授课培训讲师、受益群众都可以通过公众号查阅消防培训计划、课程详情、讲师评价等。将传统的本地化消防培训教育场景转变为在线化、信息化、阳光化。</span>
          <span class="part1_header_txt3">训管通系统针对当前各区、大队消防宣传培训人员上报培训计划不明确、现场培训不规范、培训报告不真实等情況，以大数据、云计算、移动互联等技术与传统成熟信息技术相结合为关键支撑，实现消防宣传培训工作标准化、信息化、精细化管理，推消防宣传培训工作的提档升级;系统具备开放性，可与现有平台进行互融互通，实现功能数据的相互调用</span>
        </div>
        <div class="part3_img">
          <img src="static/image/cm_Principle.png" alt="">
        </div>
      </div>
    </div>
    <div class="part3Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">解决方案</span>
          <span class="part1_header_txt2">训管通系统深度围绕智慧消防建设依据与标准</span>
        </div>
      </div>
    </div>
    <div class="part5Box">
      <div class="part5_content">
        <div class="part5_content_btn">
          训管通系统主要功能
        </div>
        <div class="part5_content_item">
          <div>

          </div>
        </div>
        <div class="part5_content_item1">
          <div></div>
          <div class="part5_content_border1"></div>
          <div class="part5_content_border"></div>
          <div></div>
        </div>
        <div class="part5_content_item2">
          <div :class="item.bgColor" v-for="(item,index) in resultList" :key="index+'resultList'" @mouseover="addActive1($event,index)" @mouseleave="removeActive1($event,index)">
            <div>
              <img :src="item.normalSrc" alt="">
            </div>
            <span :class="item.txt1Class">{{item.txt1}}</span>
            <span :class="item.txt2Class" v-for="(item1,index1) in item.txt2" :key="index1">{{item1}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part6Box">
      <div class="part6_content">
        <div class="part6_item">
          <span class="part6_squ"></span><span class="part6_content_txt1">各区培训开展情况，一目了然</span>
        </div>
        <div class="part6_content_img">
          <img src="static/image/cm_screenshot_1.png" alt="">
        </div>
        <div class="part6_item">
          <span class="part6_squ"></span><span class="part6_content_txt1">工作计划状态分类，实现精细化管理</span>
        </div>
        <div class="part6_content_img">
          <img src="static/image/cm_screenshot_2.png" alt="">
        </div>
        <div class="part6_item">
          <span class="part6_squ"></span><span class="part6_content_txt1">工作计划状态分类，实现精细化管理</span>
        </div>
        <div class="part6_content_img">
          <img src="static/image/cm_screenshot_3.png" alt="">
        </div>
      </div>
    </div>
    <div class="part7Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">客户案例</span>
          <span class="part1_header_txt2">训管通系统深度围绕智慧消防建设依据与标准</span>
        </div>
        <div class="part7_item_txt">
          南京市消防支队训管通系统
        </div>
        <div class="part6_content_img">
          <img src="static/image/cm_screenshot_4.png" alt="">
        </div>
      </div>
    </div>
    <div class="part8Box">
      <div class="part8_content">
        <div>
          <img src="static/image/cm_Effect.png" alt="">
        </div>
      </div>
    </div>
    <RegisterCom></RegisterCom>
    <FooterCom></FooterCom>
  </div>

</template>

<script>
  import HeaderCom from "../common/headerCom"
  import FooterCom from "../common/footerCom"
  import RegisterCom from "../common/registerCom"
  export default {
    name: "communicationManage",
    components: {HeaderCom, FooterCom, RegisterCom},
    data(){
      return{
        resultList:[
          {
            normalSrc:"static/image/cm_icon1.png",
            txt1:"宣传培训计划管理",
            txt2:["消防宣传计划","消防培训计划"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/cm_icon2.png",
            txt1:"宣传培训内容管理",
            txt2:["宣传内容管理","培训内容管理"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/cm_icon3.png",
            txt1:"宣传培训现场管理",
            txt2:["培训人员扫码定位","开课、结课","受训人员扫码签到","在线考试、有奖答题","效果评价、培训报告"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/cm_icon4.png",
            txt1:"一张图检测预警",
            txt2:["现场培训情况","群众参与情况","宣传培训反馈情况","群众消防意识预警"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/cm_icon5.png",
            txt1:"综合管理",
            txt2:["注册管理","宣传培训资料、题库","现场宣传MPI点码","宣传培训记录、报告管理、人才库管理","其它平台对接..."],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
        ],
      }
    },
    methods:{
      addActive1(e,index){
        this.resultList[index].normalSrc = "static/image/cm_iconActive"+(index+1)+".png";
        this.resultList[index].bgColor = "part5_item2_info part5_item2_infoActive";
        this.resultList[index].txt1Class = "part5_item2_txt1 part5_item2_txt1Active";
        this.resultList[index].txt2Class = "part5_item2_txt2 part5_item2_txt2Active";
      },
      removeActive1(e,index){
        this.resultList[index].normalSrc = "static/image/cm_icon"+(index+1)+".png";
        this.resultList[index].bgColor = "part5_item2_info";
        this.resultList[index].txt1Class = "part5_item2_txt1";
        this.resultList[index].txt2Class = "part5_item2_txt2";
      },
    }
  }
</script>

<style scoped>
  @import  '../../assets/css/bannerCom.css';
  .cm_btn{
    background: #1568FF;
  }
  .part1Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 0 60px 0;
  }
  .part1_content{
    width: 1200px;
    box-sizing: border-box;
    padding: 60px 0 0 0;
  }
  .part1_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .part1_header>span:nth-of-type(1){
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part1_header>span:nth-of-type(2){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 30px 0 60px 0;
  }
  .part1_section{
    width: 100%;
    /*height: 300px;*/
    box-sizing: border-box;
    display: flex;
  }
  .part1_section>div:nth-of-type(1){
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(1){
    font-size:20px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
    line-height:30px;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(2){
    display: inline-block;
    width:30px;
    height:3px;
    background:rgba(42,98,255,1);
    box-sizing: border-box;
    margin: 30px 0;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(3){
    width: 519px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
  }
  .part1_section>div:nth-of-type(2){
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: right;
  }
  .part1_header_txt1{
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part1_header_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 20px 0 55px 0;
  }
  .part1_header_txt3{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 0 30px 0;
  }
  .part2Box{
    width:100%;
    background:rgba(238,242,254,1);
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 0 60px 0;
  }
  .part3Box{
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }
  .part3_img{
    text-align: center;
    box-sizing: border-box;
    padding: 60px 0;
  }
  .part5Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    background:#ffffff;
  }
  .part5_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .part5_content_btn{
    width:280px;
    height:60px;
    background:rgba(42,98,255,1);
    border-radius:5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .part5_content_item{
    width: 1000px;
    height: 58px;
    border-bottom:1px solid rgba(227,227,227,1);
    border-radius:1px;
  }
  .part5_content_item>div{
    width: 50%;
    height: 100%;
    border-right:1px solid rgba(227,227,227,1);
    border-radius:1px;
  }
  .part5_content_item1{
    width: 1000px;
    height: 48px;
    box-sizing: border-box;
    display: flex;
    border-right:1px solid rgba(227,227,227,1);
    border-left:1px solid rgba(227,227,227,1);
  }
  .part5_content_item1>div{
    flex: 1;
  }
  .part5_content_item2{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .part5_item2_info{
    width:180px;
    height:350px;
    background:rgba(240,240,240,1);
    border-radius:5px;
    display: flex;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    padding: 30px 16px 0 16px;
    cursor: pointer;
    text-align: center;
  }
  .part5_item2_infoActive{
    background: #2A62FF;
  }
  .part5_item2_txt1{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(42,98,255,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .part5_item2_txt1Active{
    color: #FFFF00;
  }
  .part5_item2_txt2{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:30px;
  }
  .part5_item2_txt2Active{
    color: #FFFFFF;
  }
  .part5_content_border1{
    border-left:1px solid rgba(227,227,227,1);
    border-right:1px solid rgba(227,227,227,1);
  }
  .part5_content_border{
    border-right:1px solid rgba(227,227,227,1);
  }
  .part5_box2_txtInfo>div{
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .part5_box2_txtInfo>div>span{
    font-size:12px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(195,206,234,1);
    line-height:22px;
  }
  .part6Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding: 30px 0;
  }
  .part6_content{
    width: 1200px;
  }
  .part6_content_img{
    text-align: center;
  }
  .part6_squ{
    display: inline-block;
    width:14px;
    height:14px;
    border:2px solid rgba(42,98,255,1);
    border-radius:50%;
    box-sizing: border-box;
    margin:  0 10px 0 0;
  }
  .part6_content_txt1{
    display: inline-block;
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(40,52,87,1);
    line-height:30px;
  }
  .part6_item{
    width: 100%;
    box-sizing: border-box;
    padding: 20px 0;
  }
  .part7Box{
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }
  .part7_item_txt{
    font-size:20px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(42,98,255,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 0 0 30px 0;
  }
  .part8Box{
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    height:640px;
    background:rgba(32,41,64,1);
    margin: 80px 0 0 0;
  }
  .part8_content{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>




// WEBPACK FOOTER //
// src/components/info/communicationManage.vue